/**
 * Class 'js-reposition' makes it possible to change the position of the element.
 * With data-selector you can point to the element where this element should be reposiotioned to
 */

function reposition(el) {
  var dataSelector = el.getAttribute('data-selector');
  if(dataSelector) {
    var selectorEl = document.querySelector(dataSelector);

    if(selectorEl) {
      selectorEl.appendChild(el);
    }
  }
}

(function(){
  var fakeModals = document.querySelectorAll('.js-reposition');

  for(var i = 0;i < fakeModals.length; i++) {
    reposition(fakeModals[i]);
  }
})();



// WEBPACK FOOTER //
// ./src/scripts/modules/reposition.js